
import { mapState, mapActions } from "vuex";
export default {
  props: {
    addon: {},
    showPrice: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isActive: false,
      variants: [],
      loading: false
    };
  },

  mounted() {
    this.syncActivestate();
  },
  watch: {
    addon() {
      this.syncActivestate();
    }
  },
  methods: {
    ...mapActions("menu", ["getAddons", "changeMenuItemStatus"]),
    syncActivestate() {
      this.isActive = this.addon.item_is_active == 1;
    },

    async handleChangeMenuItemStatus(itemId, status) {
      this.loading = true;
      try {
        await this.changeMenuItemStatus({ itemId, status });
        await this.getAddons({ forceFetch: true });
      } catch (error) {
        this.isActive = !this.isActive;
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.loading = false;
    }
  }
};
